module.exports = __webpack_public_path__ + "static/img/OM1.aeefe120.png";